import { Outlet } from "react-router";

export function AdminHome() {
  return (
    <>
      <main className="flex-1 overflow-auto px-5 md:mx-8 lg:mx-24 xl:mx-48">
        <Outlet />
      </main>
    </>
  );
}
